import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import { greens, greys, white } from '@/styles/colors';
import { sansSerif } from '@/styles/typography';

// Figma: Corporate Account — Discovery, "Key Documents". Documents render as grouped rows under
// section headers, replacing the flat Name / Document Type grid the panels used to draw.

const HEADER_GREY = '#8A8F98';

export const Panel = styled.div`
    ${sansSerif}
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const PanelHeader = styled.div`
    align-items: flex-start;
    display: flex;
    gap: 16px;
    justify-content: space-between;
`;

export const PanelTitle = styled.span`
    color: #0c0b1d;
    display: block;
    font-size: 15px;
    font-weight: 700;
`;

export const PanelSubtitle = styled.span`
    color: ${greys.subtitle};
    display: block;
    font-size: 13px;
    margin-top: 2px;
`;

export const GroupCard = styled.div`
    background: ${white.primary};
    border: 1px solid ${greys.border};
    border-radius: 10px;
    overflow: hidden;
`;

export const GroupHeader = styled.div`
    align-items: center;
    background: ${white.secondary};
    border-bottom: 1px solid ${greys.border};
    color: ${HEADER_GREY};
    display: flex;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.7px;
    padding: 12px 20px;
    text-transform: uppercase;
`;

export const DocumentRow = styled.div`
    align-items: center;
    border-bottom: 1px solid ${greys.border};
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 14px 20px;

    &:last-of-type {
        border-bottom: none;
    }
`;

export const DocumentName = styled.span`
    color: #0c0b1d;
    display: block;
    font-size: 15px;
    font-weight: 700;
    overflow-wrap: anywhere;
`;

export const DocumentMeta = styled.span`
    color: ${greys.subtitle};
    display: block;
    font-size: 12.5px;
    margin-top: 2px;
`;

export const RowActions = styled.div`
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    gap: 8px;
`;

// The design badges a slot as "On file". Here every row that exists *is* on file, so the badge
// would be tautological — it is the two actions that carry the information instead.
export const ViewLink = styled.a`
    ${sansSerif}
    color: ${greens.primary};
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
        color: ${greens.primary};
        text-decoration: underline;
    }
`;

export const OutlinedAction = styled(Button)`
    ${sansSerif}
    border: 1px solid ${greys.border};
    border-radius: 6px;
    color: ${greys.secondary};
    font-size: 13px;
    font-weight: 700;
    min-width: 0;
    padding: 4px 16px;
    text-transform: none;
`;

export const EmptyState = styled.div`
    align-items: center;
    border: 1px dashed ${greys.border};
    border-radius: 10px;
    color: ${greys.primary};
    display: flex;
    font-size: 14px;
    justify-content: center;
    padding: 2rem 1rem;
`;

export const Field = styled.div`
    margin-bottom: 1rem;
`;

export const FieldLabel = styled.span`
    color: ${greys.secondary};
    display: block;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 0.5rem;
`;

export const FileSelected = styled.div`
    align-items: center;
    background: ${white.secondary};
    border: 1px solid ${greys.border};
    border-radius: 8px;
    color: ${greys.secondary};
    display: flex;
    font-size: 14px;
    gap: 8px;
    justify-content: center;
    height: 100px;
`;
